import { captureException } from '@sentry/nextjs'

import { isEnvelopErrorWithStatus } from '@/types/api-helpers'

const NOT_FOUND_CODES = ['entity.not.found', 'invalid.input', 'invalid.slug', 'product_not_found', 'record.not.found']

export function isNotFoundFetchError(error: unknown) {
    const errorEnvelop = Array.isArray(error) ? error.at(0) : null
    const typedErrorEnvelop = isEnvelopErrorWithStatus(errorEnvelop) ? errorEnvelop : null

    if (!typedErrorEnvelop) return false

    return (
        typedErrorEnvelop.status === 404 ||
        (!!typedErrorEnvelop.code && NOT_FOUND_CODES.includes(typedErrorEnvelop.code))
    )
}

export function reportFetchError(tag: string, context: string, error: unknown) {
    const errorException = new Error(`[${tag}]. ${context} - ${error}`)

    captureException(errorException)

    return errorException
}
